import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { PolicyStatus } from 'src/app/enums/proposal.enums';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { UpdatePolicyStatusModal } from 'src/app/shared/components/policy-status-update-modal/policy-status-update-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { BaseStepperAction } from '../base-action';

@Component({
  selector: 'app-suspend-policy-action',
  standalone: true,
  imports: [
    CommonModule,
    NgbTooltipModule,
    UpdatePolicyStatusModal,
    IconsModule,
    ActionModalComponent,
  ],
  templateUrl: './suspend-policy.component.html',
})
export class SuspendPolicyStepperActionComponent extends BaseStepperAction {
  @ViewChild('statusModal') statusModal: UpdatePolicyStatusModal;

  get enabled() {
    const status = this.state?.insuranceFlowData?.status;
    return (
      status === InsuranceFlowStatus.PENDING_ACTIVATION ||
      status === InsuranceFlowStatus.POLICY_ARCHIVED ||
      status === InsuranceFlowStatus.POLICY_ACTIVE
    );
  }

  get policy(): ProposalDetails {
    return this.state?.policy;
  }

  PolicyStatus = PolicyStatus;
}
